export const PLAYER_PROGRESS = {
  PLAYER_PROGRESS_INDENT_DEFAULT: '--player-progress-indent-default',
} as const
export type PLAYER_PROGRESS =
  (typeof PLAYER_PROGRESS)[keyof typeof PLAYER_PROGRESS]
